import { useEffect, useState } from "react";

/**
 * Returns true when the viewport is at or below the given max-width (px).
 * Used to switch between the desktop grid and the mobile carousel WITHOUT
 * changing any desktop behavior — the desktop branch is the default and the
 * mobile branch only activates below the breakpoint.
 */
export function useIsMobile(maxWidth = 820): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== "undefined" ? window.innerWidth <= maxWidth : false
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // Set initial + subscribe
    setIsMobile(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [maxWidth]);

  return isMobile;
}
